import { useMemo, useEffect, useCallback } from 'react';
import { useNode } from '@craftjs/core';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { FormFieldProps } from 'src/features/generalForms/builder/types/BaseControlTypes';
import { useHookFormConditional } from '../useConditional';

export const useFieldState = (form: UseFormReturn<FieldValues>) => {
  const { dataKey, disabled } = useNode((node) => ({
    disabled: (node.data.props as FormFieldProps).disabled,
    dataKey: (node.data.props as FormFieldProps).dataKey,
  }));

  const { visible, enable } = useHookFormConditional(form);

  const isDisabled = useMemo(() => disabled || !enable, [enable, disabled]);

  const unmountValue = useCallback(() => {
    form.unregister(dataKey);
    form.resetField(dataKey);
    form.clearErrors(dataKey);
  }, [dataKey, form]);

  useEffect(() => {
    if (isDisabled || !visible) unmountValue();
    return () => unmountValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled, visible]);

  return { visible, isDisabled };
};
